export const existingCustomer = "I have Xfinity Service";

export const newCustomer = "I do not have Xfinity Service";

export const businessCustomer = "I am an Xfinity Business customer";
